<template>
    <product-groups></product-groups>
</template>

<script>
import ProductGroups from '@/components/configuration/productGroups/ProductGroups.vue';

export default {
    components: {
        ProductGroups
    }
}
</script>